/**
 * Shared Socket.IO transport settings for the records gateway and manage client.
 */
export enum WebsocketTransportEnum {
  /** Socket.IO namespace for record realtime events. */
  NAMESPACE = '/ws',
  /** Socket.IO HTTP path. */
  SOCKET_IO_PATH = '/socket.io',
  /** Preferred transport. */
  TRANSPORT = 'websocket',
}
